itsoftApp.createModule("animateScroll", ["windowResize", "startLoad"], function () {
    const module = this;
    let pageHeader = document.querySelector("[data-fixed='true']");
    let viewportSize = itsoftApp.commonVars.viewWidth;

    const libraries = {
        smoothScroll: {
            name: "smoothScroll",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
        }
    };

    const ResponsiveScroll = function ({target, targetTrigger, clickedScrollFlag, settings}) {
        this.exemplar = "";
        this.targetTrigger = targetTrigger;
        this.target = target;
        this.settings = settings;
        this.clickedScrollFlag = clickedScrollFlag;
        this.defaultPadding = 0;
        this.maxMobileWidth = 767;
        this.speed = 300;
        this.init();
    };

    ResponsiveScroll.prototype.startScroll = function () {
        const RESPONSIVE_SCROLL = this;

        if (pageHeader) {
            if (this.target.hasAttribute("data-offset")) {
                if (viewportSize <= this.maxMobileWidth) {
                    this.defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                } else {
                    this.defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
                }
            } else if (this.target.hasAttribute("data-offset-mobile") && viewportSize <= this.maxMobileWidth) {
                this.defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
            } else {
                this.defaultPadding = itsoftApp.commonVars.headerHeight;
            }
        }

          /* добавляем отступ сверху, если, например, есть фиксированная шапка */
        this.settings = {
            offset: this.defaultPadding
        };

        /* вычисляем скорость и время, за которое произойдёт прокрутка */

        if (this.speed) {
            this.settings.speed = this.speed;
        }

        this.settings.durationMin = 500;

        if (this.speedAsDuration) {
            this.settings.speedAsDuration = this.speedAsDuration;
        }

        this.settings.customEasing = function (time) {
            return -(Math.cos(Math.PI * time) - 1) / 2;
        };

          /* Уничтожаем предыдущий экземпляр, если он есть */
        if (this.exemplar) {
            this.exemplar.cancelScroll();
            this.exemplar.destroy();
            this.exemplar = "";
        }
          
        this.exemplar = new SmoothScroll(); // eslint-disable-line

        if (!document.body.classList.contains("is-popup-opened")) {
            this.exemplar.animateScroll(this.target, "auto", this.settings);
        } else {
            setTimeout(function () {
                RESPONSIVE_SCROLL.exemplar.animateScroll(this.target, "auto", this.settings);
            }, 800);
        }
    };

    ResponsiveScroll.prototype.init = function () {
        const RESPONSIVE_SCROLL = this;

        new itsoftApp.modules.startLoad.callback(function () {
            if (!RESPONSIVE_SCROLL.clickedScrollFlag) {
                RESPONSIVE_SCROLL.startScroll();
            } else {
                RESPONSIVE_SCROLL.targetTrigger.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    let scrollId = evt.currentTarget.href;
                  
                    if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
                        return;
                    }

                    /* Находим элемент, до которого нужно прокрутить страницу, и передаём его в функцию */
                    RESPONSIVE_SCROLL.target = document.querySelector("#" + scrollId);
                    RESPONSIVE_SCROLL.startScroll();
                });
            }
        }, libraries.smoothScroll);

        return true;
    };

    const links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (targetTrigger) {
        const clickedScrollFlag = true;
        new ResponsiveScroll({targetTrigger, clickedScrollFlag});
    });

    const hash = location.hash;
    const hashElement = hash ? document.querySelector(hash) : null;

    itsoftApp.modules.pageLoad.addEvent(function () {
        setTimeout(function () {
            if (hash && hashElement) {
                const target = hashElement;
                new ResponsiveScroll({target});
            }
        }, 500);
    });

    module.callback = ResponsiveScroll;

    return module;
});